// Iter-439 — Single source for the insurance savings claim (owner-approved
// Insurify wording, 2026-11-02). Replaces every legacy "$487" mention.
export const INSURIFY_SAVINGS_FIGURE = "$1,100";

export const INSURIFY_SAVINGS_DISCLOSURE =
  "Average potential savings based on initial quotes received by 183,234 customers seeking insurance through Insurify. Actual savings may vary depending on state of residence, individual circumstances, coverage selections, and insurance provider. Savings results are not guaranteed.";

export const INSURIFY_SAVINGS_CLAIM =
  "Insurify reports $1,100 in average potential annual savings, based on initial quotes received by 183,234 customers seeking insurance through Insurify. Actual savings vary and are not guaranteed.";

export const INSURIFY_SAVINGS_SHORT =
  "Insurify reports $1,100 in average potential annual savings (based on initial quotes; not guaranteed).";

// For mid-sentence use (no trailing period).
export const INSURIFY_SAVINGS_INLINE =
  "Insurify reports $1,100 in average potential annual savings based on initial quotes, not guaranteed";
